// Module
var code = "<react-component name=\"BulkAddMembersToGradingEvent\"></react-component>\n";
// Exports
module.exports = code;